import classNames from 'classnames';
import * as React from 'react';
import styles from './Nav.module.scss.js';

var Nav = React.memo(function (props) {
    var root = props.root, routes = props.routes;
    var navClass = classNames(styles.nav, props.className);
    var onRouteClick = function (route) { return function () {
        var path = "" + root + route.path;
        props.onRouteClick(path);
    }; };
    return (React.createElement("nav", { className: navClass }, routes.map(function (route, index) {
        var _a;
        var path = "" + root + route.path;
        var isActive = path === props.selectedPath;
        var navItem = classNames(styles.navItem, (_a = {},
            _a[styles.navItemActive] = isActive,
            _a));
        var count = route.badgeCount && route.badgeCount > 99 ? "99+" : "" + route.badgeCount;
        return (React.createElement("a", { key: "NavItem-" + route.path, className: navItem, onClick: onRouteClick(route) },
            React.createElement("span", null, route.title),
            route.badgeCount ? React.createElement("div", { className: styles.badge }, count) : null));
    })));
});

export { Nav, Nav as default };
//# sourceMappingURL=Nav.js.map
